import React, { useState } from "react";
import API from "../api.js";
import { useNavigate } from "react-router-dom";
import InputField from "../components/ui/InputField";
import { toast } from "react-toastify";
import { COLORS } from "../config/theme";
import { MESSAGES } from "../config/messages";
import { VALIDATION } from "../utils/validation.js";
function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await API.post("/auth/login", formData);

      localStorage.setItem("token", data?.token);
      localStorage.setItem("user", JSON.stringify(data?.user));

      toast.success(MESSAGES.loginSuccess);
      navigate("/");
    } catch (err) {
      toast.error(
        err?.response?.data?.message || MESSAGES.loginError
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="max-w-md w-full bg-slate-900 p-8 rounded-2xl border border-slate-800 shadow-2xl">
        <h2 className="text-3xl font-bold text-white mb-6 text-center">
          Welcome Back
        </h2>

        <form onSubmit={handleSubmit} className="space-y-5">

          <InputField
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="your@email.com"
            required
          />

          <InputField
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="••••••••"
            required
            minLength={VALIDATION.minPasswordLength}
          />

          <button
            type="submit"
            disabled={loading}
            className={`w-full ${COLORS.primary} text-white font-bold py-3 rounded-xl transition-all ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>

        </form>

        <p className="text-slate-500 text-center mt-6 text-sm">
          Don't have an account?{" "}
          <span
            onClick={() => navigate("/register")}
            className="text-blue-400 cursor-pointer hover:underline"
          >
            Create one
          </span>
        </p>
      </div>
    </div>
  );
}

export default Login;